import { render, staticRenderFns } from "./BracketScheduleSettings.vue?vue&type=template&id=7522cc37&scoped=true"
import script from "./BracketScheduleSettings.vue?vue&type=script&lang=js"
export * from "./BracketScheduleSettings.vue?vue&type=script&lang=js"
import style0 from "./BracketScheduleSettings.vue?vue&type=style&index=0&id=7522cc37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522cc37",
  null
  
)

export default component.exports